import { DaoService } from "./DaoService";

export class AffaireService extends DaoService {

    static CLASS_NAME = "App\\Models\\Affaire";

    static getInstance() {
        return super.getInstance('affaire');
    }

    all() {
        return AffaireService.get(`${this.prefix}/all`);
    }

    search(data) {
        return AffaireService.post(`${this.prefix}/search`, data);
    }

    changeStep(uid, data) {
        return AffaireService.post(`${this.prefix}/${uid}/change-step`, data);
    }

    getResponsables(filters) {
        return AffaireService.post(`${this.prefix}/responsables`, filters);
    }

    searchForLink(searchText, excludeId, uid) {
        return AffaireService.post(`${this.prefix}/search-for-link`, { searchText, exclude_id: excludeId, uid });
    }

    getLiens(uid) {
        return AffaireService.get(`${this.prefix}/${uid}/liens`);
    }

    createLien(data) {
        return AffaireService.post(`${this.prefix}/lien`, data);
    }

    updateLien(uid, data) {
        return AffaireService.put(`${this.prefix}/lien/${uid}`, data);
    }

    deleteLien(uid) {
        return AffaireService.delete(`${this.prefix}/lien/${uid}`);
    }

}